import React from "react";
import "./Loading.css";

const Loading = () => {
  return <div className="loading__con">
      <div className="loading"></div>
  </div>;
};

export default Loading;
